export interface ISiteLocationDetailTbl {
	siteLocationId: number;
	name?: string;
	fullAddress?: string;
	siteStatusStr?: string;
	teamName?: string;
	wasEquipmentVerifiedByTeamLead?: string;
	siteStatus?: any;
	dateStart?: Date;
	dateEnd?: Date;
	clientId: number;
	addressId: number;
	addressOne?: string;
	addressTwo?: string;
	city?: string;
	state?: string;
	zipCode?: string;
	assets?: any;
	assetIds?: number[];
};

export class SiteLocationDetailTbl implements ISiteLocationDetailTbl {
	siteLocationId = 0;
	name = '';
	fullAddress = '';
	siteStatusStr = '';
	teamName = '';
	wasEquipmentVerifiedByTeamLead = '';
	siteStatus = '';
	dateStart = new Date();
	dateEnd = new Date();
	clientId = 0;
	addressId = 0;
	addressOne = '';
	addressTwo = '';
	city = '';
	state = '';
	zipCode = '';
	assets = '';
	assetIds = [];
};
